import { render, staticRenderFns } from "./VideoCateCenterTable.vue?vue&type=template&id=1ab5ea30&scoped=true&"
import script from "./VideoCateCenterTable.vue?vue&type=script&lang=js&"
export * from "./VideoCateCenterTable.vue?vue&type=script&lang=js&"
import style0 from "./VideoCateCenterTable.vue?vue&type=style&index=0&id=1ab5ea30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab5ea30",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCheckbox,VIcon,VSimpleTable})
